module.exports = __webpack_public_path__ + "static/media/landiscape-dark.7651ffca.svg";